<template>
  <div>
    <div class="baic_content">
      <div>
        <div id="guide-page-one">
          <h3>基础信息</h3>
          <div class="bacle_input">
            <h5>{{ examState === "true" ? "考试" : "练习" }}名称:</h5>
            <el-input
              type="text"
              placeholder="请输入考试名称"
              v-model.trim="textarea"
              maxlength="30"
              show-word-limit
              resize="none"
              class="check_textarea"
            >
            </el-input>
          </div>
          <div class="bacle_input">
            <h5>组卷模式:</h5>
            <div @click="groupbtn">
              <el-input
                v-model="input1"
                placeholder="请选择组卷模式"
                class="check_input"
                readonly
              ></el-input>
            </div>

            <el-button @click="groupbtn">请选择</el-button>
          </div>
          <div class="bacle_input">
            <h5>命题方式:</h5>
            <div @click="waybtn">
              <el-input
                v-model="input2"
                placeholder="请选择命题方式"
                class="check_input"
                style="outline: none"
                readonly
              ></el-input>
            </div>
            <el-tooltip
              class="item"
              effect="darkts"
              placement="right"
              v-if="(input1 === '精准组卷') === isShow"
            >
              <div slot="content" class="prompt">
                请先选择组卷模式，再选择命题方式。
              </div>
              <el-button @click="waybtn">请选择</el-button>
            </el-tooltip>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="operation">
          <el-button class="succ_btn" @click="backfor">返回</el-button>
          <el-button
            type="success"
            class="submit_btn"
            :loading="buttonLoding"
            @click="examRepeat"
            >下一步</el-button
          >
        </div>
      </div>
    </div>
    <!-- 提示小弹窗 -->
    <div class="delete_view">
      <el-dialog title="温馨提示" :visible.sync="lncompleteHint">
        <div class="delete_mian">
          <i class="iconfont icon-tishi1"></i>
          <p>试卷名称重复，请重新填写！</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="lncompleteHint = false">取 消</el-button>
          <el-button type="primary" @click="lncompleteHint = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 弹窗 -->
    <OnePup
      ref="popup"
      :cutcoms="cutcoms"
      @callbackfun="callbackfun"
      @callback="callback"
    />
  </div>
</template>

<script>
import $guideSteps from "@/utils/guideSteps";
import $utils from "@/utils/commonUtils";
import OnePup from "./OnePup.vue";
import loginvuex from "@/store/index";
import { examIsExists } from "@/api/index.js";
export default {
  name: "Pageone",
  data() {
    return {
      textarea: "", //考试名称
      input1: "", //组卷模式
      input2: "", //命题方式
      isShow: false,
      lncompleteHint: false, // 试卷重复拦截弹窗
      driver: null,
      buttonLoding: false, // 防抖
      examState: "", // 是否是考试进入
    };
  },
  props: ["cutcoms"],
  components: {
    OnePup,
  },
  methods: {
    backfor() {
      this.$parent.back();
    },
    // 试卷重复拦截
    async examRepeat() {
      if (!this.textarea || !this.input1 || !this.input2) {
        this.$message({
          message: "警告，请填写试卷名称且选好组卷模式",
          type: "warning",
        });
        return;
      }
      let res = {
        examName: this.textarea, // 考试名称
        examType: "online",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        examID: "",
      };
      this.buttonLoding = true;
      const Data = await examIsExists(res);
      if (Data.status === 200) {
        if (Data.data.Data.count == 0) {
          this.Nexstep();
          setTimeout(() => {
            this.buttonLoding = false;
          }, 500);
        } else {
          this.buttonLoding = false;
          this.lncompleteHint = true;
        }
      }
      //判断试卷是否存在
    },
    Nexstep() {
      if (this.textarea !== "" && this.input1 !== "" && this.input2 !== "") {
        switch (this.input1) {
          case "智能组卷":
            this.cutcoms(1);
            break;
          case "权重组卷":
            this.cutcoms(1);
            this.$parent.addweighttest();
            break;
          case "试卷组卷":
            this.cutcoms(1.1);
            break;
          case "精准组卷":
            this.cutcoms(1.2);
            break;
          case "难易度组卷":
            this.cutcoms(1);
            break;
        }
      } else {
        this.$refs.popup.dialogVisibleObj.lncompleteHint = true;
      }
      this.$emit("sendmdoe", this.textarea, this.input1, this.input2);
    },
    groupbtn() {
      if (!sessionStorage.getItem("practice") && this.$refs.popup.groupModeList.length==4) {
      // 考试新增难易度组卷
        const obj = {
          isActive: false,
          type: "weight",
          title: "难易度组卷",
          placement: "left-start",
          effect: "dark2",
          imgUrl: require("@/assets/groupmode/pic5.png"),
          text: " 选定好出题范围，设置好每个范围需要出题的数量，系统智能抽取试题。",
        };
        this.$refs.popup.groupModeList.push(obj);
      }
      this.$refs.popup.dialogVisibleObj.groupmode = true;
    },
    waybtn() {
      if (this.input1 === "精准组卷") {
        return;
      }
      this.$refs.popup.dialogVisibleObj.Proposition = true;
    },
    callbackfun(item) {
      if (item === "精准组卷") {
        this.input2 = "手动命题";
      }
      if (item != "精准组卷" && this.input2 === "手动命题") {
        this.input2 = "";
      }
      this.input1 = item;
    },
    callback(item) {
      this.input2 = item;
    },
  },
  async activated() {
    let guideSteps = await $utils.getUserGuideList("zxksPageOneSteps");
    this.examState = sessionStorage.getItem("examState"); // 是否是考试进入
    this.driver = $utils.getGuideDriver();
    setTimeout(() => {
      this.$nextTick(() => {
        $utils.initGuideDriver(this.driver, guideSteps);
      });
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
.baic_content {
  background-color: white;
  min-width: 1527px;
  padding-bottom: 80px;
  border-radius: 4px 4px 4px 4px;
  h3 {
    display: inline-block;
    width: 100%;
    height: 60px;
    background: #cce7ff;
    border-radius: 4px 4px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    padding-top: 17px;
    padding-left: 24px;
  }
  .bacle_input {
    display: flex;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.prompt {
  width: 147px;
  height: 28px;
  padding: 2px 1px;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 240px 0 0px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-input__inner {
  border: 1px solid #dcdfe6;
}
// 弹窗
.delete_view {
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .delete_mian {
    display: flex;
    box-sizing: border-box;
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
    &:nth-child(2) {
      margin-left: 30px;
    }
  }
}
::v-deep .delete_view .el-dialog {
  width: 300px;
  height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
  }
}
</style>
